/*eslint-disable*/
import React from "react";
import { useLocation } from "react-router-dom"; 
import { 
  FaTachometerAlt, 
  FaBoxOpen, 
  FaList, 
  FaWarehouse, 
  FaShoppingCart, 
  FaUsers,
  FaClipboard,
  FaWpforms, 

} from "react-icons/fa";
import "./Sidebar.css";
import logo from "../src/images/mysore-oils-logo.jpeg";
import { Link } from "react-router-dom";

export default function Sidebar() {
  const location = useLocation();

  const routes = [
    { name: "Dashboard", path: "/dashboard", icon: <FaTachometerAlt /> },
    { name: "Products", path: "/products", icon: <FaBoxOpen /> },
    { name: "Categories", path: "/categories", icon: <FaList /> },
    // { name: "Inventory", path: "/inventory", icon: <FaWarehouse /> },
    { name: "Orders", path: "/orders", icon: <FaShoppingCart /> },
    { name: "Customers", path: "/customers", icon: <FaUsers /> },
    { name: "Banner Management", path: "/banner", icon: <FaClipboard/>},
    { name: "Contact Form Management", path: "/contact-form", icon: <FaWpforms/>}

  ];
  
  return (
    <div className="sidebar">
      <div className="sidebar-logo">
      <img
          src={logo}
          alt="Admin Logo"
          style={{ width: "100%", padding: "20px", objectFit: "contain" }}
        />
      </div>
      <div className="sidebar-links">
        {routes.map((route, index) => (
         <Link
  key={index}
  to={route.path}
  className={`sidebar-link ${
    location.pathname === route.path ? "active" : ""
  }`}
>
  <span className="sidebar-icon">{route.icon}</span>
  <span className="sidebar-text">{route.name}</span>
</Link>

        ))}
      </div>
    </div>
  );
}
